/** Keep in sync with server/services/item-types.js FINISHED_GOOD_ITEM_TYPES */
const FINISHED_GOOD_ITEM_TYPES = new Set([
  'Finished Goods',
  'Beer-Kegged',
  'Beer-Packaged',
  'Spirits-Packaged',
  'Soda',
]);

/**
 * Vendor product numbers are for purchasable items only — not Finished Goods or WIP.
 */
export function allowsVendorItemCodes(type?: string, name?: string): boolean {
  const t = String(type || '').trim();
  if (FINISHED_GOOD_ITEM_TYPES.has(t)) return false;
  const lower = t.toLowerCase();
  if (lower === 'wip' || lower === 'wip items' || /\bwip\b/.test(lower)) return false;
  if (name && /\bWIP\b/i.test(String(name))) return false;
  return true;
}
